export const categories = [
  {
    slug: "zuixin-baoliao",
    name: "最新爆料",
    description: "51cg平台最新曝光信息，第一时间掌握真相",
    icon: "ri-flashlight-line",
  },
  {
    slug: "yonghu-pingjia",
    name: "用户评价",
    description: "真实用户使用体验与反馈汇总",
    icon: "ri-chat-3-line",
  },
  {
    slug: "shendu-fenxi",
    name: "深度分析",
    description: "专业剖析51cg平台运营模式与问题",
    icon: "ri-search-eye-line",
  },
  {
    slug: "fengxian-tishi",
    name: "风险提示",
    description: "使用51cg平台需注意的潜在风险",
    icon: "ri-alert-line",
  },
  {
    slug: "neimu-jiemi",
    name: "内幕揭秘",
    description: "揭开51cg平台不为人知的内幕",
    icon: "ri-spy-line",
  },
];

export const categoryMap: Record<string, typeof categories[number]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});